import styles from '../styles/EventLog.module.css';

interface EventLogProps {
  events: Array<{
    time: string;
    source: 'client' | 'server';
    event: any;
  }>;
  formatTime: (time: string) => string;
}

export function EventLog({ events, formatTime }: EventLogProps) {
  return (
    <div className={styles.eventsLog}>
      {events.map((event, i) => {
        // Get summary text based on event type
        let summaryText = event.event.type;
        if (event.event.response?.output?.[0]?.content?.[0]?.text) {
          summaryText = event.event.response.output[0].content[0].text;
        } else if (event.event.type === 'response.function_call_arguments.done') {
          summaryText = `${event.event.name}(${JSON.stringify(event.event.arguments)})`;
        }

        return (
          <div key={i} className={styles.eventLine}>
            <span className={styles.eventTimeInline}>{formatTime(event.time)}</span>
            <details className={styles.eventContent}>
              <summary>
                <span className={`${styles.eventSource} ${styles[event.source]}`}>
                  {summaryText}
                </span>
              </summary>
              <pre className={styles.eventDetails}>
                {JSON.stringify(event.event, null, 2)}
              </pre>
            </details>
          </div>
        );
      })}
    </div>
  );
}
